import { Button, Rating, Skeleton } from "@mui/material";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import ManageTestimonials from "./ManageTestimonials";
import { privateAxiosIntance } from "../../Config/axios";

export const headers = {
  token: localStorage.getItem("token"),
  Authorization: `Token ${localStorage.getItem("token")}`,
};

const Testimonials = () => {
  const [data, setData] = useState([]);
  const [selected, setSelected] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const testimonialsFn = async () => {
    setIsLoading(true);
    try {
      const response = await privateAxiosIntance.get("/client-feedback-api/");
      setData(response.data.data);
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    testimonialsFn();
  }, []);

  const deleteTestimonialsFn = async (client_feedback_ids) => {
    try {
      const response = await privateAxiosIntance.delete(
        "/client-feedback-api/",
        { data: { client_feedback_ids } },
      );
      toast.success(response?.data?.message);
      testimonialsFn();
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <div className="p-0">
      {/* Heading */}
      <p className="my-3 sm:my-0 text-2xl sm:text-4xl md:text-5xl text-center text-blue-900 underline">
        Testimonials
      </p>

      {/* Manage Button */}
      <div className="flex justify-end pb-1 items-center">
        <ManageTestimonials
          refetch={testimonialsFn}
          setSelected={setSelected}
          selected={selected}
        />
      </div>

      {/* Grid */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {isLoading
          ? [1, 2, 3, 4, 5, 6].map((i) => (
              <div
                key={i}
                className="flex flex-col p-3 bg-gray-100 rounded shadow-inner"
              >
                <div className="flex flex-col gap-2">
                  <div className="flex items-center justify-between">
                    <Skeleton className="w-40" />
                    <Skeleton className="w-32" />
                  </div>
                  <Skeleton className="w-1/2" />
                  <Skeleton />
                  <Skeleton variant="rectangular" height={160} />
                </div>
              </div>
            ))
          : data?.map((item) => (
              <div
                key={item.id}
                className="flex flex-col justify-between p-3 bg-gray-100 rounded shadow-inner"
              >
                {/* Content */}
                <div className="flex flex-col gap-1">
                  <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-1">
                    <p className="text-lg sm:text-xl font-semibold">
                      {item.client}
                    </p>
                    <Rating readOnly value={item.feedback} />
                  </div>

                  <p className="text-black font-semibold text-opacity-80">
                    {item.designation}
                  </p>

                  <p className="text-xs  sm:text-base">{item.comment}</p>

                  {item.url && (
                    <div className="relative w-full pt-[56.25%] mt-2">
                      <iframe
                        src={item.url}
                        title="Client testimonial video"
                        className="absolute top-0 left-0 w-full h-full rounded"
                        frameBorder="0"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                        allowFullScreen
                      ></iframe>
                    </div>
                  )}
                </div>

                {/* Actions */}
                <div className="flex flex-col sm:flex-row gap-2 pt-3">
                  <Button
                    fullWidth
                    variant="outlined"
                    onClick={() => setSelected(item)}
                  >
                    Update
                  </Button>

                  <Button
                    fullWidth
                    color="error"
                    variant="outlined"
                    onClick={() => deleteTestimonialsFn([item.id])}
                  >
                    Delete
                  </Button>
                </div>
              </div>
            ))}
      </div>
    </div>
  );
};

export default Testimonials;
